import React from "react";

export default function FormField({ label, htmlFor, error, children, styles, className }) {
  return (
    <div className={className || styles?.inputGroup}>
      {label ? <label htmlFor={htmlFor}>{label}</label> : null}
      {children}
      {error ? <div className={styles?.errorMessage}>{error}</div> : null}
    </div>
  );
}
